import { render } from "./basic-info.vue?vue&type=template&id=9554c404&scoped=true"
import script from "./basic-info.vue?vue&type=script&lang=js"
export * from "./basic-info.vue?vue&type=script&lang=js"

import "./basic-info.vue?vue&type=style&index=0&id=9554c404&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9554c404"]])

export default __exports__